import TabFirm from './TabFirm-redux';

export default TabFirm;
